export const config = {
  employeeDirectoryVersion: '6.6.9.7',
  userPollVersion: '1.0.6.1',
};
